import "./style.scss";
import $ from "jquery";

$(document).ready(function () {
    $('.ow_read_more_wrap').find('.read_more_buttton_more').click(function (event) {
        event.preventDefault();
        $(this).hide();
        $(this).parent().find('.ow_read_more_more').slideToggle('fast');
        $(this).parent().find('.read_more_buttton_less').show();
    });
    $('.ow_read_more_wrap').find('.read_more_buttton_less').click(function (event) {
        event.preventDefault();
        $(this).hide();
        $(this).parent().find('.ow_read_more_more').slideToggle('fast');
        $(this).parent().find('.read_more_buttton_more').show();
    });
});